
<div class="container my-5" *ngIf="marketplaceItem">
  <div [innerHTML]="marketplaceItem.TermsAndConditions"></div>
</div>
